import { render } from "./CardThirtyFive.vue?vue&type=template&id=0c1588d2"
import script from "./CardThirtyFive.vue?vue&type=script&lang=js"
export * from "./CardThirtyFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__